import { Button } from '@chakra-ui/react'
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog"
import { colors } from '../../utilities/colors'

const ActionConfirmPopup = ({ isOpen, onClose, onConfirm, cancelRef, title, body, confirmText }) => {
  return (
    <DialogRoot
      role='alertdialog'
      open={isOpen}
      leastDestructiveRef={cancelRef}
      onOpenChange={onClose}
    >
      <DialogTrigger />
      <DialogContent bg={colors.deepOcean}>
        <DialogCloseTrigger />
        <DialogTitle>
          <div className="text-lg font-bold m-2">{title}</div>
        </DialogTitle>
        <DialogBody>
          {body}
        </DialogBody>
        <DialogFooter>
          <Button
            ref={cancelRef}
            onClick={onClose}
            sx={{
              borderRadius: 'full'
            }}
          >
            Cancel
          </Button>
          <Button
            bg={colors.red}
            onClick={onConfirm}
            ml={3}
            p={2}
            borderRadius='full'
          >
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  )
}

export default ActionConfirmPopup
